var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var dataColum = [
    {
        editable: false,
        field: "quote",
        flex: 1,
        headerName: "Cotización",
        width: 150,
        renderCell: function (params) { return (_jsx("div", __assign({ style: { color: "rgb(58, 86, 161)" } }, { children: params.value }))); },
    },
    {
        editable: false,
        field: "identification",
        flex: 1,
        headerName: "Identificación",
        width: 200,
    },
    {
        editable: false,
        field: "name",
        flex: 1,
        headerName: "Nombre",
        width: 150,
    },
    {
        editable: false,
        field: "firstSurname",
        flex: 1,
        headerName: "Primer apellido",
        width: 150,
    },
    {
        editable: false,
        field: "secondSurname",
        flex: 1,
        headerName: "Segundo apellido",
        width: 150,
    },
    {
        field: "marriedName",
        flex: 1,
        headerName: "Apellido Casada",
        width: 150,
    },
    {
        field: "status",
        flex: 1,
        headerName: "Estatus póliza",
        width: 150,
    },
    {
        field: "branch",
        flex: 1,
        headerName: "Sucursal",
        width: 150,
    },
    {
        field: "user",
        flex: 1,
        headerName: "Usuario",
        width: 150,
    },
];
